import { FC } from 'react'

import { Typography } from '@mui/material'

const PageHeading: FC<{ title: string, icon?: any }> = ({ title, icon=null }) => {
  return (
    <Typography variant='h2' sx={{ fontFamily: 'Newsreader', fontWeight: '400', fontSize: '2rem', padding: '1rem 0 0 1rem' }}>
      {icon} {title} 
    </Typography>
  )
}
export default PageHeading
